import React, { Component, PropTypes } from 'react';
import { Button, Well } from 'react-bootstrap';
import formValidation from '../../utils/formValidation';
import { onInputChange } from '../../utils/helpers';
import { Input } from '../inputs';

export default class Login extends Component {
  static propTypes = {
    onLoginClick: PropTypes.func.isRequired,
    isAuthenticating: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      formErrors: [],
      credentials: {
        nation: '',
        password: '',
      },
      isShowPassword: false,
    };

    this.onInputChange = onInputChange().bind(this);
  }

  togglePassword = () => {
    const { isShowPassword } = this.state;

    this.setState({ isShowPassword: !isShowPassword });
  };

  handleLoginClick = e => {
    e.preventDefault();

    const { credentials } = this.state;

    formValidation({
      loginCredentials: credentials,
    }).then(formErrors => {
      this.setState({ formErrors });

      if (!!formErrors.length) {
        return;
      }

      const { onLoginClick } = this.props;

      onLoginClick(credentials);
    });
  };

  render() {
    const { isAuthenticating } = this.props;

    const { formErrors, credentials, isShowPassword } = this.state;

    const btnShowPassword = (
      <Button type="button" onClick={this.togglePassword} tabIndex="-1" style={{ marginTop: 0 }}>
        <i className={isShowPassword ? 'fa fa-eye-slash' : 'fa fa-eye'} />
      </Button>
    );

    return (
      <div className="form-login">
        <h3>Please Sign In</h3>

        <Well>
          If you are a NF and do not have an access to this entry system or need any help please
          contact{' '}
          <a href={`mailto:${window.cviConfig.supportEmail}`}>{window.cviConfig.supportEmail}</a>.
        </Well>

        <form>
          <Input
            type="text"
            value={credentials.nation}
            onChange={this.onInputChange('credentials.nation')}
            placeholder="Ex. SVK"
            label="Nation (short)"
            autoFocus
            errors={formErrors}
            name="nation"
          />

          <Input
            type={isShowPassword ? 'text' : 'password'}
            value={credentials.password}
            onChange={this.onInputChange('credentials.password')}
            buttonAfter={btnShowPassword}
            placeholder="Password"
            label="Password"
            errors={formErrors}
            name="password"
          />

          <Button
            type="submit"
            onClick={this.handleLoginClick}
            disabled={isAuthenticating}
            bsStyle="primary"
            block
          >
            Sign In
          </Button>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/Login.js